var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.queryLabels[0],
                prop: _vm.cptQueryProps[0],
                "label-width": _vm.labelWidth[0],
              },
            },
            [
              _c("BjSelectLov", {
                attrs: {
                  "lov-code": "SCHL.CHANNEL_TYPE",
                  disabled: _vm.disabled,
                  placeholder: _vm.queryLabels[0],
                },
                on: { change: _vm.handleChannelChange },
                model: {
                  value: _vm.queryParams[_vm.cptQueryKeys[0]],
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, _vm.cptQueryKeys[0], $$v)
                  },
                  expression: "queryParams[cptQueryKeys[0]]",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.queryLabels[1],
                prop: _vm.cptQueryProps[1],
                "label-width": _vm.labelWidth[1],
              },
            },
            [
              _c("BjSelectStore", {
                attrs: {
                  "collapse-tags": _vm.collapseTags,
                  "option-value": _vm.storeOptionValue,
                  multiple: _vm.multiple,
                  "default-params": {
                    channelTypeCode: _vm.queryParams[_vm.cptQueryKeys[0]],
                    cusId: _vm.queryParams.cusId || null,
                  },
                  placeholder: _vm.queryLabels[1],
                  disabled:
                    !_vm.queryParams[_vm.cptQueryKeys[0]] || _vm.disabled,
                },
                on: { change: _vm.handleStoreChange },
                model: {
                  value: _vm.queryParams[_vm.cptQueryKeys[1]],
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, _vm.cptQueryKeys[1], $$v)
                  },
                  expression: "queryParams[cptQueryKeys[1]]",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }